import { debounce } from 'lodash-es'
import { useCallback, useEffect, useState } from 'react'

import { useTagsStore } from '@/feature/tags'
import { usePersistentObservatoryPageStore } from '@/feature/observatory'

import { useAllAssets } from '@/lib/features/Assets/api'

export const useObservatoryAssets = () => {
  const assetFilterState = usePersistentObservatoryPageStore((state) => state.assetsFilters)
  const assetSearch = usePersistentObservatoryPageStore((state) => state.assetsSearch)

  const [updatedAssetSearch, setUpdatedAssetSearch] = useState(assetSearch)

  const { filteringTags } = useTagsStore()

  const updateAssetSearch = useCallback(
    debounce(
      (search: string) => {
        setUpdatedAssetSearch(search)
      },
      750,
      {
        leading: false,
        trailing: true,
        maxWait: 1000,
      },
    ),
    [],
  )

  useEffect(() => {
    updateAssetSearch(assetSearch)
    return () => updateAssetSearch.cancel()
  }, [assetSearch])

  const res = useAllAssets({
    bridgeIsActiveMap: true,
    pageSize: Number.MAX_SAFE_INTEGER,
    myAssets: !assetFilterState.toggles['Shared With Me'],
    excludeMyVehicles: !assetFilterState.toggles['My Assets'],
    excludePtu: !assetFilterState.toggles.PTU,
    search: updatedAssetSearch,
    tagsSearch: filteringTags.map((tag) => tag.name).join(', '),
  })

  res.isLoading &&= updatedAssetSearch === assetSearch

  return res
}
